import React from "react";
import styled from "styled-components";
import RadioButton from "../buttons/RadioButton";
import PaymentButton from "../buttons/PaymentButton";


const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.div`
  margin: auto;
`;
const Spacer = styled.div`
  height: 45px;
  width: 100%;
  margin: 0;
  margin-top: -4px;
`;
const Address = styled.div``;
const Title = styled.div`
  font-size: 15px;
  font-weight: 500;
`;
const Flex = styled.div`
  display: flex;
  width: inherit;
  justify-content: space-between;
  gap: 10px;
`;
const Input = styled.input`
  width: 97%;
  margin-top: 10px;
  padding: 12px 10px;
  font-size: 12px;
  background-color: transparent;
  border: 1px solid #b4b4b4;
  outline: 2px solid transparent;
  outline-offset: 2px;
  &::placeholder {
    color: #6e6b6b;
  }
  &:focus {
    outline: #6b7280;
  }
`;
const Select = styled.div`
  background-color: transparent;
  border: 1px solid #b4b4b4;
  outline: 2px solid transparent;
  width: 49%;
  margin-top: 10px;
  select {
    width: 100%;
    border: none;
    font-size: 13px;
    padding: 10px;
    background-color: white;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #6e6b6b;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;
  }
`;
const Method = styled.div``;
const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 12px;
  background-color: #b4b4b4;
`;
const Payment = styled.div``;

function CheckoutForm() {
  return (
    <Wrapper>
      <Container>
        <Spacer></Spacer>
        <Address>
          <Title>DELIVERY ADDRESS</Title>
          <Flex>
            <Input placeholder="First Name*" />
            <Input placeholder="Last Name*" />
          </Flex>
          <Input placeholder="Your Address*" />
          <Input placeholder="C/O" />
          <Flex>
            <Input placeholder="Zip / Postal Code*" />
            <Input placeholder="City*" />
          </Flex>
          <Select>
            <select>
              <option>Nepal</option>
              <option>India</option>
              <option>China</option>
              <option>Sweden</option>
            </select>
          </Select>
          <Input placeholder="Your Email*" />
          <Input placeholder="Phone Number*" />
        </Address>
        <Spacer></Spacer>
        <Method>
          <Title>DELIVERY METHOD</Title>
          <Line></Line>
          <RadioButton />
          <RadioButton />
          <RadioButton />
        </Method>
        <Spacer></Spacer>
        <Payment>
          <Title>PAYMENT METHOD</Title>
          <Line></Line>
          <PaymentButton />
          <PaymentButton />
          <PaymentButton />
          <PaymentButton />
        </Payment>
      </Container>
    </Wrapper>
  );
}

export default CheckoutForm;